// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__fQN4X","iconWrap":"EmptyState_iconWrap__8fx0q","title":"EmptyState_title__oq4Fo","sub":"EmptyState_sub__frjYn","action":"EmptyState_action__uhAH8"};